import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import fetch from 'cross-fetch';

import type { ConfigStateContext } from '../../client/shared/hooks/useConfig';

const headerLink = (config: ConfigStateContext) =>
  setContext(async (_, { headers }) => {
    const newHeaders = {
      ...headers,
      'seek-request-country': config.country,
      'seek-request-brand': config.brand,
    };

    return {
      headers: newHeaders,
    };
  });

const getGraphQLEndpoint = (config: ConfigStateContext) => {
  if (config.environment === 'development') return '/feature-flags';
  if (config.environment === 'staging')
    return `https://www.staging.seek.com.au/graphql`;
  return `https://www.seek.com.au/graphql`;
};

const httpLink = (config: ConfigStateContext) =>
  createHttpLink({
    uri: getGraphQLEndpoint(config),
    fetch,
  });

export const candidateApolloClient = (config: ConfigStateContext) =>
  new ApolloClient({
    link: headerLink(config).concat(httpLink(config)),
    cache: new InMemoryCache(),
  });
